export default "__VITE_ASSET__DGQ9FTjo__"